<script lang="ts">
    import {onMount} from "svelte";
    import {AuthStore} from "../../store/AuthStore";


    onMount(() => {
    });

    $: authStoreAuthStatus = AuthStore.authStatus;


</script>
<div class="footer-view">
    <div class="content">
        <div>
            開発・運用: バンダイナムコスタジオ 技術スタジオ 技術活用推進部 ITソリューションチーム
        </div>
        <div class="small-link-area">
            {#if $authStoreAuthStatus === AuthStore.AuthStatusType.authorized}
                <a href="/api/auth/logout">
                    ログアウト
                </a>
            {/if}

            <a href="https://bnsi.slack.com/archives/C04PL0KBLLV" target="_blank" rel="noreferrer noopenner">
                問い合わせチャンネル(BNS Slack)
            </a>
            <a href="https://forms.office.com/r/wj77HNrFiR" target="_blank" rel="noreferrer noopenner">
                アンケート
            </a>

            <a href="/#/rights_notation">
                権利表記
            </a>
        </div>

    </div>

</div>
<style lang="scss">
    .footer-view {
        margin-top: 256px;
        background-color: var(--color1);
        color: var(--color3);
        padding-top: 32px;
        padding-bottom: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        > .content {
            text-align: center;

            .small-link-area {
                font-size: 12px;

                display: flex;
                align-items: center;
                justify-content: center;
                gap: 24px;

                > a {
                    margin-top: 14px;
                    opacity: 0.5;

                    &:hover {
                        opacity: 1;
                    }
                }
            }

        }


    }
</style>
